import { UseMutationOptions } from '@tanstack/react-query';
import { getZaplifySdk } from '@zaplify/sdk';
import { LinkedinPostDto } from '@andsend/services-linkedin-profiles-shared';

const createLinkedinPostFn = (posts: LinkedinPostDto[]) => {
    return getZaplifySdk().profiles.linkedinPosts.addLinkedinPost(posts);
};
type LinkedinPostData = Awaited<ReturnType<typeof createLinkedinPostFn>>;
export const createLinkedinPost = (
    options?: Omit<UseMutationOptions<LinkedinPostData, Error, LinkedinPostDto[]>, 'mutationFn'>
): UseMutationOptions<LinkedinPostData, Error, LinkedinPostDto[]> => {
    return {
        mutationFn: createLinkedinPostFn,
        ...options,
    };
};
